import classNames from 'classnames';
import React from 'react';

import '@eika/card-style/src/InfoCard.scss';

export interface InfoCardTitleProps {
    children: string;
}

const TitleH1 = ({ children }: InfoCardTitleProps): JSX.Element => <h1 className="typography-h1__light">{children}</h1>;
const TitleH2 = ({ children }: InfoCardTitleProps): JSX.Element => <h2 className="typography-h2">{children}</h2>;
const TitleH3 = ({ children }: InfoCardTitleProps): JSX.Element => <h3 className="typography-h3">{children}</h3>;

export interface InfoCardImageProps {
    src: string;
    alt: string;
}

const Image: React.FC<InfoCardImageProps> = ({ src, alt }) => {
    return <img src={src} alt={alt} />;
};

type DivElementProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
export interface InfoProps extends DivElementProps {
    className?: string;
    skipBackground?: boolean;
    asHeader?: boolean;
    img?: JSX.Element;
}

interface InfoCardComposition {
    TitleH1: React.FC<InfoCardTitleProps>;
    TitleH2: React.FC<InfoCardTitleProps>;
    TitleH3: React.FC<InfoCardTitleProps>;
    Image: React.FC<InfoCardImageProps>;
}

const InfoCard: React.FC<InfoProps> & InfoCardComposition = ({
    className,
    skipBackground,
    children,
    asHeader = false,
    img,
    ...rest
}) => {
    return (
        <div
            className={classNames(
                className,
                'sgw-info-card',
                { 'show-background': !skipBackground },
                { 'as-header': asHeader },
            )}
            {...rest}
        >
            {img && <div className="sgw-info-card__img-wrapper">{img}</div>}
            {asHeader ? (
                <div className="sgw-info-card__content-wrapper typography-paragraph">{children}</div>
            ) : (
                children
            )}
        </div>
    );
};

InfoCard.TitleH1 = TitleH1;
InfoCard.TitleH2 = TitleH2;
InfoCard.TitleH3 = TitleH3;
InfoCard.Image = Image;

export default InfoCard;
